import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

export default function Loader() {
  return (
    <Spin
      // size="large"
      indicator={
        <LoadingOutlined
          spin
          style={{
            fontSize: 44,
            color: '#000000',
          }}
        />
      }
    />
  );
}
